import { defineStore } from 'pinia'
import { showMessage } from '@/common/utils'

interface PaginationCache<T> {
  [page: number]: {
    data: T[]
  }
}

export const useAiCreateStore = defineStore('aiCreate', {
  state: () => ({
    selectedTaskType: '',
    selectedGenerateModeIndex: 0,
    selectedNumberIndex: 1,
    selectedRatioIndex: -1,
    imgProductOrigin: null,
    imgProductMask: null,
    imgProductEditted: null,
    imgProductReference: null,
    refImageDescription: '',
    refImagePageData: {} as Record<string, PaginationCache<any>>,
    refImagePageIndex: 0,
    customMessage: '',
    runningTaskId: '',
    runningTaskType: '',
    runningTaskMessage: '',
    generatedGroupList: [],
    //  0: 没有正在执行生成任务 1: 正在执行但还没有生成返回 2: 正在执行且已有部分生成返回 3: 全部生成完成
    generateState: 0,
  }),
  getters: {},
  actions: {
    setSelectedTaskType(task_type: string) {
      this.selectedTaskType = task_type
    },
    setSelectedGenerateModeIndex(index: number) {
      this.selectedGenerateModeIndex = index
    },
    setCurNumberIndex(index: number) {
      this.selectedNumberIndex = index
    },
    setSelectedRatioIndex(index: number) {
      this.selectedRatioIndex = index
    },
    setImgProductOrigin(img: any) {
      this.imgProductOrigin = img
    },
    setImgProductMask(img: any) {
      this.imgProductMask = img
    },
    setImgProductEditted(img: any) {
      this.imgProductEditted = img
    },
    setImgProductReference(img: any) {
      this.imgProductReference = img
    },
    setRefImageDescription(desc: string) {
      this.refImageDescription = desc
    },
    setRefImagePageData(pagn_index: number, list: any[]) {
      this.refImagePageData[pagn_index] = list
    },
    clearReferenceImagePageData() {
      this.refImagePageData = {}
    },
    setRefImagePageIndex(index: number) {
      this.refImagePageIndex = index
    },
    setCustomMessage(msg: string) {
      this.customMessage = msg
    },
    setGenerateState(state: number) {
      this.generateState = state
    },
    setRunningTaskId(id: string) {
      this.runningTaskId = id
    },
    setRunningTaskType(type: string) {
      this.runningTaskType = type
    },
    setRunningTaskMessage(msg: string) {
      this.runningTaskMessage = msg
    },
    setGeneratedGroupList(list: any[]) {
      this.generatedGroupList = list
    },
    addToGeneratedGroupList(item: any) {
      this.generatedGroupList.push(item)
    },
    checkIsGenerating() {
      if ([1, 2].includes(this.generateState)) {
        showMessage(
          'Please wait for the previous generation to complete',
          'warning'
        )
        return true
      }
      return false
    },
    clearExhibition() {
      this.generateState = 0
      this.runningTaskId = ''
      this.runningTaskType = ''
      this.generatedGroupList = []
    },
    clearLeftMenu() {
      this.imgProductOrigin = null
      this.imgProductMask = null
      this.imgProductEditted = null
      this.imgProductReference = null
      this.refImagePageData = {}
      this.customMessage = ''
      this.selectedNumberIndex = -1
      this.selectedRatioIndex = -1
    },
  },
})
